<template>
    <a-row :gutter="20" class="info">
      <a-col :span="6" >
        <div style="margin-left: 20px">
          项目状态：
          <project-status :status="project.status"></project-status>
        </div>
        <div class="time-line base-row">
          <a-timeline>
            <a-timeline-item v-for="(item,index) in project.changeList" :key="index">
              <p>{{item.createTime}}</p>
              {{item.operation}}
            </a-timeline-item>
          </a-timeline>

        </div>
        <div class="base-row tip-title">
          项目自首次启动已进行<label class="num">{{projectDay}}</label>天
        </div>
        <div class="base-row tip-title">
          预计结束时间：<label class="num">{{project.planEndDate}}</label>
        </div>
        <div class="base-row">
          <a-tooltip class="info-row" >
            <template slot="title">
              {{project.intro}}
            </template>
            <div class="one-row">
              项目简介：{{project.intro}}
            </div>
          </a-tooltip>
          <div class="info-row">
            申办人：{{project.projectCreateUserName}}
          </div>
          <div class="info-row">
            联系人：{{project.contactName}}
          </div>
          <div class="info-row">
            联系电话：{{project.contactPhone}}
          </div>
          <div class="info-row">
            研究类型：{{project.researchType}}
          </div>
          <div class="info-row">
            设计方案：{{project.designScheme}}
          </div>
        </div>
      </a-col>
      <a-col :span="18">
        <a-card title="纳入排除标准" >
          <filtrate :projectId="projectId" style="height: calc(100vh - 640px);overflow-y: auto" :isEdit="false"></filtrate>
        </a-card>
        <a-card title="文档资料" style="margin-top: 5px">
          <a-table :columns="columns" :data-source="project.fileList"
                   size="small"
          :scroll="{y:'170px'}"
          >
            <span slot="action" slot-scope="text,record,index">
               <a @click="downloadFileHandle(record)">下载</a>

            </span>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
</template>

<script>
  import Filtrate from '../components/Filtrate'
  import { getAction,downloadFile } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME,statusData } from '@/constants/project'
  import Vue from 'vue'
  import ProjectStatus from '../../management/project/projectList/ProjectStatus'
  export default {
    name: 'Info',
    components: { ProjectStatus, Filtrate },
    data(){
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) || '',
        project:{
          fileList:[],
          changeList:[],
        },
        columns:[
          {
            title: '文档名称',
            align:'center',
            dataIndex: 'name',
          },
          {
            title: '上传人',
            align:'center',
            dataIndex: 'createBy',
            width: 80,
          },
          {
            title: '上传日期',
            align:'center',
            dataIndex: 'createTime',
          },
          {
            title: '文件大小',
            align:'center',
            dataIndex: 'size',
            customRender: (t, r, i) => {
              if(t>1024*1024){
                return (t/1024/1024).toFixed(2) +'M'
              }else{
                return (t/1024).toFixed(2)+'KB'
              }
            }
            // ellipsis: true, 表格省略
          },
          {
            title: '操作',
            align:'center',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
      }
    },
    computed:{
      projectDay(){
        if(this.project.startDate){
          const new_date = new Date();                      //新建一个日期对象，默认现在的时间
          const old_date = new Date(this.project.startDate); //设置过去的时间点
          const subtime = (new_date - old_date) / 1000;    //计算时间差,并将毫秒转化为秒
          let days = parseInt(subtime / 86400);  //天  24*60*60*1000
          if(subtime % 86400 >1){
            days+=1
          }
          return `${days}`
        }
        return '0'
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        getAction('/management/project/getProjectInfoById',{id:this.projectId}).then(res=>{
          if(res.success){
            this.project = res.result
          }
        })
      },
      downloadFileHandle(record){
        downloadFile('/sys/common/static'+record.path,record.name)
      }
    }
  }
</script>

<style scoped lang="less">
  .info{
    .time-line{
      height:300px;
      overflow-y: auto;

    }
    .base-row{
      margin-top: 10px;
      margin-left: 20px;
    }
    .tip-title{
      color: rgba(0,0,0,0.4);
    }
    .num{
      color: #2599DE;
      font-size: 20px;
    }
    .info-row{
      margin-top: 15px;
    }
    .stan-title{
      font-size: 16px;
    }
    .stan-info{
      max-height: 120px;
      overflow-y: auto;
    }
  }
</style>